import { render, staticRenderFns } from "./PersonalSpace.vue?vue&type=template&id=921cbb5a&"
import script from "./PersonalSpace.vue?vue&type=script&lang=js&"
export * from "./PersonalSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports